import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from 'src/app/faq/core/services/configuration.service';
import { CommonDataFaqService } from './common-data-faq.service';
import { map } from 'rxjs/internal/operators/map';
import { FaqInstanceClientDTO } from '@shared/models/faq-instance-client-dto.model';
import { LanguageService } from '@shared/services/language.service';

@Injectable({ providedIn: 'root' })
export class ConfigurationResolve {
    favicon: HTMLLinkElement;

    constructor(
        private commonDataFaqService: CommonDataFaqService,
        private configurationService: ConfigurationService,
        private languageService: LanguageService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.favicon = this.document.querySelector('#favicon');
    }

    resolve(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<FaqInstanceClientDTO> {
        this.commonDataFaqService.communityName = activatedRouteSnapshot.params.communityName;
        this.commonDataFaqService.faqName = activatedRouteSnapshot.params.faqName;

        return this.configurationService.getFAQInfo(activatedRouteSnapshot.params.faqName).pipe(
            map((data) => {
                this.commonDataFaqService.faqSettings = data;
                this.commonDataFaqService.displayName = data.displayName;
                this.commonDataFaqService.faqName = data.name;
                if (data.faviconUrl) {
                    this.favicon.href = data.faviconUrl;
                } else {
                    this.favicon.href = 'sb-tools/theme/images/sb-logo/zisson-socialboards-24px.svg';
                }
                this.languageService.initLanguage();
                return data;
            }),
        );
    }
}
